module.exports = __webpack_public_path__ + "static/media/proximanova-reg-webfont.fc024b78.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/resources/fonts/proximanova-reg-webfont.eot
// module id = 154
// module chunks = 0